import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import {Option} from "ts-option";
import User from "../../model/user/User";
import {Redirect, Route, RouteProps} from "react-router";

interface ReduxProps {
	user: Option<User>
}

interface RolesProps {
	/**
	 * Roles allowed for route
	 */
	allowedPermissions?: string[]
}

type Props = ReduxProps & RouteProps & RolesProps;

/**
 * Route that is restricted for given roles
 * Every user that want to enter restricted route and doesn't have access will be redirected to main page (the same after login).
 */
class RestrictedRoute extends Route<Props> {
	render() {
		const Component = this.props.component;
		return this.props.user.get.hasPermissions(this.props.allowedPermissions) ? <Route render={props => <Component/>}/> : <Redirect to={"/"}/>;
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user
	}
}

export default connect(mapStateToProps)(RestrictedRoute)
